module.exports = __webpack_public_path__ + "img/slide-1.ed2ba32f.jpg";